module.exports = __webpack_public_path__ + "static/media/adelaide-logo.05183a67.svg";